import React, { useEffect, useState } from 'react';
import ProjectTaskList from './ProjectTaskList'
import AddTaskModal from './AddTaskModal'
import EditTaskModal from './EditTaskModal';
import CloseTaskModal from './CloseTaskModal';
import ProjectTaskDoneModal from './ProjectTaskDoneModal';
import TaskRemakrsModal from './TaskRemakrsModal';
import DeleteTaskModal from './DeleteTaskModal';
import { PrivateAxios } from '../../../environment/AxiosInstance';
import { useParams } from 'react-router-dom';
import { SuccessMessage } from '../../../environment/ToastMessage';
import { UserAuth } from '../../auth/Auth';

function ProjectDetailsIndex() {
    const { id } = useParams(); // Project ID
    const { MatchPermission } = UserAuth();

    // --- Shared State ---
    const [taskData, setTaskData] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null);

    // --- Modals ---
    const [showAddPTaskModal, setShowAddPTaskModal] = useState(false);
    const [showEditPTaskModal, setShowEditPTaskModal] = useState(false);
    const [showClosePTaskModal, setShowClosePTaskModal] = useState(false);
    const [showProjectTaskDoneModal, setShowProjectTaskDoneModal] = useState(false);
    const [showTaskRemarksModal, setShowTaskRemarksModal] = useState(false);
    const [showDeleteTaskModal, setShowDeleteTaskModal] = useState(false);

    // --- Fetch tasks ---
    useEffect(() => {
        if (!id) return;
        
        // Only fetch tasks if user has permission
        if (!MatchPermission(['Add Project', 'View Project', 'Edit Project', 'Delete Project', 'Project All'])) {
            return;
        }

        const fetchTasks = async () => {
            try {
                const res = await PrivateAxios.get(`/projecttasks/tskbyid/${id}`);
                if (res.data?.success) setTaskData(res.data.data || []);
                else setTaskData([]);
            } catch (err) {
                console.error("Error fetching tasks:", err);
            }
        };
        fetchTasks();
    }, [id, MatchPermission]);

    // ================== PERMISSION CHECK AFTER ALL HOOKS ==================
    // Only allow users with project permissions to access this page
    if (!MatchPermission(['Add Project', 'View Project', 'Edit Project', 'Delete Project', 'Project All'])) {
        return (
            <div className="p-4 text-center">
                <h4>Access Denied</h4>
                <p>You don't have permission to view project details.</p>
            </div>
        );
    }

    const handleTaskDeleted = (deletedTaskId) => {
        setTaskData(prev => prev.filter(task => task.id !== deletedTaskId));
        SuccessMessage("Task deleted successfully");
    };

    // --- Modal Handlers ---
    const handleShowEditPTaskModal = (task) => { setSelectedTask(task); setShowEditPTaskModal(true); };
    const handleShowClosePTaskModal = (task) => { setSelectedTask(task); setShowClosePTaskModal(true); };
    const handleShowProjectTaskDoneModal = (task) => { setSelectedTask(task); setShowProjectTaskDoneModal(true); };
    const handleShowTaskRemarksModal = (task) => { setSelectedTask(task); setShowTaskRemarksModal(true); };
    const handleShowDeleteTaskModal = (task) => { setSelectedTask(task); setShowDeleteTaskModal(true); };
    console.log("selectedTask",selectedTask)
    return (
        <div className='p-4'>
            <div className='mb-4'>
                <a className="text-dark back-btn me-3" href="/projects">
                    <i className="fas fa-long-arrow-alt-left me-1" />
                    Back
                </a>
            </div>

            <ProjectTaskList
                taskData={taskData}          // Pass taskData as prop
                setTaskData={setTaskData}    // Optional: allow child to update tasks
                handleShowAddPTaskModal={MatchPermission(['Add Project', 'Project All']) ? () => setShowAddPTaskModal(true) : null}
                handleShowEditPTaskModal={MatchPermission(['Edit Project', 'Project All']) ? handleShowEditPTaskModal : null}
                handleShowClosePTaskModal={MatchPermission(['Edit Project', 'Project All']) ? handleShowClosePTaskModal : null}
                handleShowProjectTaskDoneModal={MatchPermission(['Edit Project', 'Project All']) ? handleShowProjectTaskDoneModal : null}
                handleShowTaskRemarksModal={MatchPermission(['View Project', 'Project All']) ? handleShowTaskRemarksModal : null}
                handleShowDeleteTaskModal={MatchPermission(['Delete Project', 'Project All']) ? handleShowDeleteTaskModal : null}
            />

            {/* Add Task Modal - only show if user has Add permission */}
            {MatchPermission(['Add Project', 'Project All']) && (
                <AddTaskModal
                    show={showAddPTaskModal}
                    handleClose={() => setShowAddPTaskModal(false)}
                />
            )}

            {/* Edit Task Modal - only show if user has Edit permission */}
            {MatchPermission(['Edit Project', 'Project All']) && (
                <EditTaskModal
                    show={showEditPTaskModal}
                    handleClose={() => setShowEditPTaskModal(false)}
                    task={selectedTask}
                />
            )}

            {/* Close Task Modal - only show if user has Edit permission */}
            {MatchPermission(['Edit Project', 'Project All']) && (
                <CloseTaskModal
                    show={showClosePTaskModal}
                    handleClose={() => setShowClosePTaskModal(false)}
                    task={selectedTask}
                />
            )}

            {/* Task Done Modal - only show if user has Edit permission */}
            {MatchPermission(['Edit Project', 'Project All']) && (
                <ProjectTaskDoneModal
                    show={showProjectTaskDoneModal}
                    handleClose={() => setShowProjectTaskDoneModal(false)}
                    task={selectedTask}
                />
            )}

            {/* Task Remarks Modal - only show if user has View permission */}
            {MatchPermission(['View Project', 'Project All']) && (
                <TaskRemakrsModal
                    show={showTaskRemarksModal}
                    handleClose={() => setShowTaskRemarksModal(false)}
                    task={selectedTask}
                />
            )}

            {/* Delete Task Modal - only show if user has Delete permission */}
            {MatchPermission(['Delete Project', 'Project All']) && (
                <DeleteTaskModal
                    show={showDeleteTaskModal}
                    handleClose={() => setShowDeleteTaskModal(false)}
                    task={selectedTask}
                    onDeleted={handleTaskDeleted}
                />
            )}
        </div>
    );
}

export default ProjectDetailsIndex;
